import { render, staticRenderFns } from "./MainJouTaraCard.vue?vue&type=template&id=08daeb0d&scoped=true&"
import script from "./MainJouTaraCard.vue?vue&type=script&lang=js&"
export * from "./MainJouTaraCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouTaraCard.vue?vue&type=style&index=0&id=08daeb0d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08daeb0d",
  null
  
)

export default component.exports